(function () {
  class MessageBar extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.reset.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._sidewinderMessage = undefined;
      this._xtraPowerMessage = undefined;
    }

    onGameConfigEvent() {
      this._sidewinderMessage = resourceManager.get(this._jsonPath + ':sidewinderMessage');
      this._xtraPowerMessage = resourceManager.get(this._jsonPath + ':xtraPowerMessage');

      this.reset();
    }

    onXtraPowerTriggerEvent(task) {
      this.showXtraPowerMessage();
    }

    showXtraPowerMessage() {
      this._sidewinderMessage.visible = false;
      this._xtraPowerMessage.visible = true;
    }

    reset() {
      this._sidewinderMessage.visible = true;
      this._xtraPowerMessage.visible = false;
    }

    onLayoutChange() {}
  }

  const creator = function (json) {
    return new MessageBar();
  };

  const filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('messageBar', creator, initialise, filesRequired);
})();
